import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-yellow-50 text-gray-800 p-4 md:p-8">
      <div className="max-w-4xl mx-auto space-y-10">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold text-center text-yellow-800"
        >
          2🐝yaaG – To Bee Yaa (You)
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-lg text-center"
        >
          A warm community guiding students to discover who they want to be — and helping them get there.
        </motion.p>

        <Card className="bg-white shadow-xl rounded-2xl">
          <CardContent className="space-y-4 p-6">
            <h2 className="text-2xl font-semibold text-yellow-700">Our Mission</h2>
            <p>
              Born from the challenges students face after the 10th standard, we provide friendly guidance to explore the wide world of careers. We offer detailed roadmaps crafted from professional experiences, especially from wise retirees excited to share their stories.
            </p>
            <p>
              More than just advice – this is a space to discover, connect, and grow.
            </p>
          </CardContent>
        </Card>

        <Card className="bg-white shadow-xl rounded-2xl">
          <CardContent className="space-y-4 p-6">
            <h2 className="text-2xl font-semibold text-yellow-700">🐝 The Story Behind 2ByaaG</h2>
            <p>
              "What do you want to be?" — a question that echoes after school. "To be" becomes our compass. Add in the affirming "yaa" we say every day… and you get: <strong>to bee yaa</strong> (to be you).
            </p>
            <p>
              2ByaaG is a constant reminder: you can be the person you dream of. And we're here to walk with you.
            </p>
          </CardContent>
        </Card>

        <Card className="bg-white shadow-xl rounded-2xl">
          <CardContent className="space-y-4 p-6">
            <h2 className="text-2xl font-semibold text-yellow-700">👥 Meet the Team</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Community Manager:</strong> Leads community engagement and content direction.</li>
              <li><strong>Content Creators:</strong> Craft posts, articles, and resources for career exploration.</li>
              <li><strong>Social Media Manager:</strong> Handles Instagram, X, LinkedIn, YouTube – builds conversations online.</li>
              <li><strong>Designer:</strong> Designs visuals and keeps the brand fresh and consistent.</li>
              <li><strong>Moderator (optional):</strong> Ensures safe and respectful conversations in large groups.</li>
            </ul>
            <p className="italic">Support roles include strategists, PR, tech, and event heads – check our full <a href="https://www.notion.so/Structure-ef4dbc579cd649b4ab2f3e374dbc2df5?pvs=21" className="text-blue-600 underline">structure</a>.</p>
          </CardContent>
        </Card>

        <Card className="bg-white shadow-xl rounded-2xl">
          <CardContent className="space-y-4 p-6">
            <h2 className="text-2xl font-semibold text-yellow-700">📜 Community Guidelines</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Respect everyone – no insults, slurs, or negativity.</li>
              <li>Share helpful, relevant content around careers.</li>
              <li>Stay on topic – we have separate spaces for off-topic chatter.</li>
              <li>Engage! Ask questions, help peers, and explore freely.</li>
              <li>Report anything harmful to moderators.</li>
            </ul>
            <p>Our space thrives on kindness, curiosity, and the courage to dream. Let's make it safe and inspiring for everyone.</p>
          </CardContent>
        </Card>

        <div className="flex justify-center gap-4 flex-wrap">
          <Button asChild>
            <Link to="/story">
              Read Full Story
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/team">
              Meet the Team
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/guidelines">
              Guidelines
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}